const lang = {
    en:{
      search:'Search',
      placeholder:'what you would like to watch👀'
    },
    hindi:{
     search:"खोज",
     placeholder:"आप क्या देखना पसंद करेंगे👀"
    },
    spanish:{
     search:'buscar',
     placeholder:'lo que te gustaría ver👀'
    }
}

export default lang